
import { Component, Vue, Ref } from 'vue-property-decorator'  // 引入Ref
import SchoolSelector from '../components/school-selector.vue'
import {
  CreateOperationsInput, OperationsManagementService, TenantWorkUserRelationshipDto,
  UserRelationshipDto, SimpleTenantDto, CreateTenantWorkUserRelationshipInput
} from "@/api/service-proxies";

@Component({
  components: { SchoolSelector }
})
export default class createAndUpdate extends Vue {
  phoneNumber = ''
  userName = ''
  name = ''
  id = Number(this.$route.params.id)
  tenantPosition = "";
  tenantNameQuery = "";

  // --------------- 新增：多选相关状态 ---------------
  @Ref('multipleLeftTable') multipleLeftTable!: any;  // 左侧表格实例
  @Ref('multipleRightTable') multipleRightTable!: any;  // 右侧表格实例
  selectedLeftSchools: SimpleTenantDto[] = [];  // 左侧选中的学校列表
  selectedRightSchools: UserRelationshipDto[] = [];  // 右侧选中的学校列表

  // 左侧：全部学校相关（不变）
  tenantId: number | null = null;
  allSchools: SimpleTenantDto[] = [];
  filteredSchools: SimpleTenantDto[] = [];
  filteredSelectOptions: SimpleTenantDto[] = [];
  currentSelectKeyword = '';

  // 右侧：已关联学校相关（不变）
  associatedTenantId: number | null = null;
  allAssociatedSchools: UserRelationshipDto[] = [];
  filteredAssociatedSchools: UserRelationshipDto[] = [];
  filteredAssociatedOptions: UserRelationshipDto[] = [];
  currentAssociatedKeyword = '';

  OperationPointsService = new OperationsManagementService()
  detailsMsgList: TenantWorkUserRelationshipDto = null
  bingUserSchoolName: UserRelationshipDto[] = []
  createOperationsInput = new CreateOperationsInput()
  createTenantWorkUserRelationshipInput = new CreateTenantWorkUserRelationshipInput()
  isSearchName = true

  mounted() {
    this.phoneNumber = ''
    if (this.id !== -1) {
      this.isSearchName = false
      this.phoneNumber = String(this.$route.params.phone) || '';
      this.getDetailsUser();
    }
    this.getData();
  }

  // 获取详情及该人管理的学校（不变）
  async getDetailsUser() {
    try {
      const result: any = await this.OperationPointsService.getTenantWorkUserRelationship(this.id);
      let relationships = [];
      if (result && result.relationships) {
        relationships = result.relationships;
      } else if (result && result.items) {
        relationships = result.items;
      } else if (Array.isArray(result)) {
        relationships = result;
      }

      this.allAssociatedSchools = relationships.map(school => ({
        tenantId: school.tenantId || school.id,
        tenantName: school.tenantName || school.name || school.tenancyName,
        ...school
      }));
      this.filteredAssociatedSchools = [...this.allAssociatedSchools];
      this.filteredAssociatedOptions = [...this.allAssociatedSchools];
      this.userName = result.userName;
      this.phoneNumber = result.phoneNumber;
      this.createTenantWorkUserRelationshipInput.tenantWorkUserId = result.tenantWorkUserId
    } catch (error) {
      this.$message.error('加载关联学校数据失败，请重试');
    }
  }

  // 获取未绑定运维学校（不变）
  async getData() {
    try {
      const result: any = await this.OperationPointsService.getCanWorkSchools(1);
      const allSchools = (result.items || []) as SimpleTenantDto[];

      this.allSchools = [...allSchools];
      this.filteredSchools = [...this.allSchools];
      this.filteredSelectOptions = [...this.allSchools];

      if (this.allAssociatedSchools.length === 0) {
        this.allAssociatedSchools = allSchools
          .filter(school => school.isRelationSchool)
          .map(school => ({
            tenantId: school.id,
            tenantName: school.name || school.tenancyName,
            ...school
          }));
        this.filteredAssociatedSchools = [...this.allAssociatedSchools];
        this.filteredAssociatedOptions = [...this.allAssociatedSchools];
      }
    } catch (error) {
      this.$message.error('加载学校数据失败，请重试');
    }
  }

  // --------------- 新增：左侧多选逻辑 ---------------
  // 左侧表格选中事件：更新选中列表
  handleLeftSelectionChange(val: SimpleTenantDto[]) {
    this.selectedLeftSchools = val;
  }

  // 左侧行点击：自动选中复选框（优化体验）
  handleLeftRowClick(row: SimpleTenantDto) {
    this.multipleLeftTable.toggleRowSelection(row);
  }

  // 左侧批量关联：处理所有选中学校的关联
  handleBatchAssociate() {
    if (this.selectedLeftSchools.length === 0) return;

    // 1. 批量移除左侧数据
    const selectedIds = this.selectedLeftSchools.map(school => school.id);
    this.allSchools = this.allSchools.filter(school => !selectedIds.includes(school.id));
    this.filteredSelectOptions = this.filteredSelectOptions.filter(school => !selectedIds.includes(school.id));
    this.filteredSchools = this.filteredSchools.filter(school => !selectedIds.includes(school.id));

    // 2. 批量添加到右侧数据
    const newAssociatedSchools = this.selectedLeftSchools.map(school => ({
      tenantId: school.id,
      tenantName: school.name || school.tenancyName,
      ...school
    } as UserRelationshipDto));
    this.allAssociatedSchools = [...this.allAssociatedSchools, ...newAssociatedSchools];
    this.filteredAssociatedOptions = [...this.filteredAssociatedOptions, ...newAssociatedSchools];
    this.filteredAssociatedSchools = [...this.filteredAssociatedSchools, ...newAssociatedSchools];

    // 3. 清空左侧选中状态
    this.multipleLeftTable.clearSelection();
    this.$message.success(`已批量关联 ${this.selectedLeftSchools.length} 所学校`);
  }

  // --------------- 新增：右侧多选逻辑 ---------------
  // 右侧表格选中事件：更新选中列表
  handleRightSelectionChange(val: UserRelationshipDto[]) {
    this.selectedRightSchools = val;
  }

  // 右侧行点击：自动选中复选框（优化体验）
  handleRightRowClick(row: UserRelationshipDto) {
    this.multipleRightTable.toggleRowSelection(row);
  }

  // 右侧批量取消关联：处理所有选中学校的取消
  handleBatchCancelAssociate() {
    if (this.selectedRightSchools.length === 0) return;

    // 1. 批量移除右侧数据
    const selectedIds = this.selectedRightSchools.map(school => school.tenantId);
    this.allAssociatedSchools = this.allAssociatedSchools.filter(school => !selectedIds.includes(school.tenantId));
    this.filteredAssociatedOptions = this.filteredAssociatedOptions.filter(school => !selectedIds.includes(school.tenantId));

    // 同步右侧表格显示（考虑搜索状态）
    if (this.currentAssociatedKeyword) {
      this.filteredAssociatedSchools = this.allAssociatedSchools.filter(
        item => item.tenantName && item.tenantName.toLowerCase().includes(this.currentAssociatedKeyword)
      );
    } else {
      this.filteredAssociatedSchools = [...this.allAssociatedSchools];
    }

    // 2. 批量添加到左侧数据
    const newNormalSchools = this.selectedRightSchools.map(school => ({
      id: school.tenantId,
      name: school.tenantName,
      tenancyName: school.tenantName,
      isRelationSchool: false,
      ...school
    } as SimpleTenantDto));
    this.allSchools = [...this.allSchools, ...newNormalSchools];
    this.filteredSelectOptions = [...this.filteredSelectOptions, ...newNormalSchools];

    // 同步左侧表格显示（考虑搜索状态）
    if (this.currentSelectKeyword) {
      this.filteredSchools = this.allSchools.filter(
        item => item.name && item.name.toLowerCase().includes(this.currentSelectKeyword)
      );
    } else {
      this.filteredSchools = [...this.allSchools];
    }

    // 3. 清空右侧选中状态
    this.multipleRightTable.clearSelection();
    this.$message.success(`已批量取消关联 ${this.selectedRightSchools.length} 所学校`);
  }

  // --------------- 原有方法：同步处理多选状态 ---------------
  // 关联学校（单条）：新增清空选中状态
  handleAssociate(school: SimpleTenantDto) {
    if (!school.id || !school.name) return;

    // 原有逻辑不变...
    this.allSchools = this.allSchools.filter(item => item.id !== school.id);
    this.filteredSelectOptions = this.filteredSelectOptions.filter(item => item.id !== school.id);
    this.filteredSchools = this.filteredSchools.filter(item => item.id !== school.id);

    const associatedSchool: UserRelationshipDto = {
      tenantId: school.id,
      tenantName: school.name || school.tenancyName,
      ...school
    };
    this.allAssociatedSchools = [associatedSchool,...this.allAssociatedSchools ];
    this.filteredAssociatedOptions = [...this.filteredAssociatedOptions, associatedSchool];
    this.filteredAssociatedSchools = [...this.filteredAssociatedSchools, associatedSchool];

    // 新增：单条关联后清空左侧选中（避免选中状态残留）
    this.multipleLeftTable.clearSelection();
    this.$message.success(`已关联学校：${school.name}`);
  }

  // 取消关联（单条）：新增清空选中状态
  handleCancelAssociate(school: UserRelationshipDto) {
    if (!school.tenantId || !school.tenantName) return;

    // 原有逻辑不变...
    this.allAssociatedSchools = this.allAssociatedSchools.filter(item => item.tenantId !== school.tenantId);
    this.filteredAssociatedOptions = this.filteredAssociatedOptions.filter(item => item.tenantId !== school.tenantId);
    if (this.currentAssociatedKeyword) {
      this.filteredAssociatedSchools = this.allAssociatedSchools.filter(
        item => item.tenantName && item.tenantName.toLowerCase().includes(this.currentAssociatedKeyword)
      );
    } else {
      this.filteredAssociatedSchools = [...this.allAssociatedSchools];
    }

    const normalSchool: SimpleTenantDto = {
      id: school.tenantId,
      name: school.tenantName,
      tenancyName: school.tenantName,
      isRelationSchool: false,
      ...school
    };
    this.allSchools = [...this.allSchools, normalSchool];
    this.filteredSelectOptions = [...this.filteredSelectOptions, normalSchool];
    if (this.currentSelectKeyword) {
      this.filteredSchools = this.allSchools.filter(
        item => item.name && item.name.toLowerCase().includes(this.currentSelectKeyword)
      );
    } else {
      this.filteredSchools = [...this.allSchools];
    }

    // 新增：单条取消后清空右侧选中（避免选中状态残留）
    this.multipleRightTable.clearSelection();
    this.$message.success(`已取消关联学校：${school.tenantName}`);
  }

  // 左侧：下拉搜索过滤（不变）
  handleSelectFilter(keyword: string) {
    this.currentSelectKeyword = keyword.trim().toLowerCase();
    this.filteredSelectOptions = !this.currentSelectKeyword
      ? [...this.allSchools]
      : this.allSchools.filter(school => school.name && school.name.toLowerCase().includes(this.currentSelectKeyword));
    this.filteredSchools = [...this.filteredSelectOptions];
    // 搜索时清空左侧选中
    this.multipleLeftTable.clearSelection();
  }

  // 左侧：下拉框清空事件处理（不变）
  handleSelectClear() {
    this.currentSelectKeyword = '';
    this.tenantId = null;
    this.filteredSelectOptions = [...this.allSchools];
    this.filteredSchools = [...this.allSchools];
    // 清空时清空左侧选中
    this.multipleLeftTable.clearSelection();
  }

  // 左侧：下拉框显示/隐藏时同步表格（不变）
  syncTableWithSelect(isVisible: boolean) {
    if (!isVisible) {
      this.filteredSchools = [...this.filteredSelectOptions];
      // 切换下拉时清空左侧选中
      this.multipleLeftTable.clearSelection();
    }
  }

  // 左侧：点击搜索按钮/选择选项时筛选（不变）
  handleSearch() {
    // 搜索时清空左侧选中
    this.multipleLeftTable.clearSelection();
    this.filteredSchools = this.allSchools;
    if(this.tenantNameQuery != undefined && this.tenantNameQuery != ''){
        this.filteredSchools =this.filteredSchools.filter(x=>x.name.toLowerCase().includes(this.tenantNameQuery.toLowerCase()))
      }
      if(this.tenantPosition != undefined && this.tenantPosition != ''){
        this.filteredSchools =this.filteredSchools.filter(x=>x.position.toLowerCase().includes(this.tenantPosition.toLowerCase()))
      }
  }

  // 右侧：下拉搜索过滤（不变）
  handleAssociatedSelectFilter(keyword: string) {
    this.currentAssociatedKeyword = keyword.trim().toLowerCase();
    this.filteredAssociatedOptions = !this.currentAssociatedKeyword
      ? [...this.allAssociatedSchools]
      : this.allAssociatedSchools.filter(school => school.tenantName && school.tenantName.toLowerCase().includes(this.currentAssociatedKeyword));
    this.filteredAssociatedSchools = [...this.filteredAssociatedOptions];
    // 搜索时清空右侧选中
    this.multipleRightTable.clearSelection();
  }

  // 右侧：下拉框清空事件处理（不变）
  handleAssociatedSelectClear() {
    this.currentAssociatedKeyword = '';
    this.associatedTenantId = null;
    this.filteredAssociatedOptions = [...this.allAssociatedSchools];
    this.filteredAssociatedSchools = [...this.allAssociatedSchools];
    // 清空时清空右侧选中
    this.multipleRightTable.clearSelection();
  }

  // 右侧：下拉框显示/隐藏时同步表格（不变）
  syncAssociatedTableWithSelect(isVisible: boolean) {
    if (!isVisible) {
      this.filteredAssociatedSchools = [...this.filteredAssociatedOptions];
      // 切换下拉时清空右侧选中
      this.multipleRightTable.clearSelection();
    }
  }

  // 右侧：点击搜索按钮/选择选项时筛选（不变）
  handleAssociatedSearch() {
    if (this.associatedTenantId) {
      this.filteredAssociatedSchools = this.allAssociatedSchools.filter(school => school.tenantId === this.associatedTenantId);
    } else {
      this.filteredAssociatedSchools = this.currentAssociatedKeyword ? [...this.filteredAssociatedOptions] : [...this.allAssociatedSchools];
    }
    // 搜索时清空右侧选中
    this.multipleRightTable.clearSelection();
  }

  // 表格行样式（不变）
  tableRowClassName(row: any, rowIndex: any) {
    if (rowIndex === 1) return 'warning-row';
    if (rowIndex === 3) return 'success-row';
    return '';
  }

  goBack() {
    this.$router.back();
  }

  // 提交关联结果（不变）
  handleSubmit() {
    let tenantIdList = this.allAssociatedSchools.map(school => school.tenantId);
    if (this.userName == undefined || this.userName == '') {
      this.$message.warning('请输入运维人名');
      return
    }
    if (this.id == -1) {
      this.createOperationsInput.phone = this.phoneNumber;
      this.createOperationsInput.name = this.userName;
      this.createOperationsInput.tenantIds = tenantIdList
      this.OperationPointsService.createOperations(this.createOperationsInput)
        .then(() => {
          this.$message.success('提交成功');
          this.goBack();
        }).catch((error: any) => {
          this.$message.error('提交失败，请重试');
        });
    } else {
      this.createTenantWorkUserRelationshipInput.name = this.userName
      this.createTenantWorkUserRelationshipInput.phone = this.phoneNumber;
      this.createTenantWorkUserRelationshipInput.tenantIds = tenantIdList
      this.OperationPointsService.createTenantWorkUserRelationship(this.createTenantWorkUserRelationshipInput)
        .then(() => {
          this.$message.success('修改成功');
          this.goBack();
        }).catch((error: any) => {
          this.$message.error('修改失败，请重试');
        });
    }
  }
}
